import { Grid2 } from "@mui/material";
import Recover from "./Restore";

export const plusActionsGrid = {
  xl: 9,
  lg: 9,
  md: 9,
  sm: 9,
  xs: 9,
};

const PlusActions = () => {
  return (
    <Grid2 container {...{ size: 3, justifyContent: "end", columnGap: 2 }}>
      <Recover />
    </Grid2>
  );
};

export default PlusActions;
